import { trackDataLayerEvent } from '../../../helpers/tracking'
import { ensureStructure } from '../../../helpers/ComponentHelper'

declare global {
  interface Window {
    digitalData: any
  }
}

const buildEvent = (eventName, eventAction, attributeData) => {
  const event = {
    eventInfo: {
      eventName,
      eventAction
    },
    attributes: {
      ...attributeData
    }
  }
  return event
}

export const hotspotTracking = (type: string, title?: string, productList?: Array<string>): void => {
  ensureStructure(window)
  const attributeData = { hotspotTitle: title, products: productList }
  const eventData = buildEvent(type, 'cms interaction', attributeData)

  window.digitalData.event.push(eventData)
  window.digitalData.track(type, eventData)
}

export const hotspotClickTracking = (sku: string, title?: string, productList?: Array<string>): void => {
  const attributeData = { hotspotTitle: title, products: productList, hotspotProductClickedOn: sku }

  trackDataLayerEvent('hotspotClicked', {}, attributeData)
}

export const quickviewTracking = (origin: string, productList?: Array<string>, title?: string): void => {
  ensureStructure(window)

  const attributeData = { products: productList }
  const pageData = {
    clickOrigin: `hotspot:${title}:${origin}`,
    type: 'hotspot'
  }

  trackDataLayerEvent('cms_hotspotLbPage', {}, attributeData)

  window.digitalData.page.lightBox = pageData
}

export const quickviewDetailsTracking = (
  type: string,
  title?: string,
  sku?: string,
  sliderPagination?: string
): void => {
  const attributeData = {
    hotspotTitle: title,
    products: { id: sku },
    ...(sliderPagination && { imagePagination: sliderPagination })
  }

  trackDataLayerEvent(type, {}, attributeData)
}
